import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showToast, hideToast } from '../actions/toast';
import Toast from '../components/Toast';

export class ToastContainer extends Component {
  render() {
    return <Toast {...this.props} />;
  }
}

export const mapDispatchToProps = dispatch => ({
  showToast: data => dispatch(showToast(data)),
  hideToast: () => dispatch(hideToast())
});

const mapStateToProps = ({ toast }) => ({
  show: toast.show,
  options: toast.options
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToastContainer);
